import { render, staticRenderFns } from "./HeroDTHBadge.vue?vue&type=template&id=792dc592&scoped=true&"
import script from "./HeroDTHBadge.vue?vue&type=script&lang=js&"
export * from "./HeroDTHBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792dc592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
